import { render, staticRenderFns } from "./coalDetails.vue?vue&type=template&id=36ad8b3c&scoped=true&"
import script from "./coalDetails.vue?vue&type=script&lang=js&"
export * from "./coalDetails.vue?vue&type=script&lang=js&"
import style0 from "./coalDetails.vue?vue&type=style&index=0&id=36ad8b3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad8b3c",
  null
  
)

export default component.exports